module.exports = __webpack_public_path__ + "img/pos.ace80a09.png";